import * as React from 'react';
import { Calendar, DayOfWeek, DateRangeType } from 'office-ui-fabric-react/lib/Calendar';
import styles from './index.module.scss';

export interface ICalendarProps {
    isMonthPickerVisible?: boolean;
    dateRangeType: DateRangeType;
    autoNavigateOnSelection: boolean;
    showGoToToday: boolean;
    showNavigateButtons?: boolean;
    highlightCurrentMonth?: boolean;
    highlightSelectedMonth?: boolean;
    isDayPickerVisible?: boolean;
    showMonthPickerAsOverlay?: boolean;
    showWeekNumbers?: boolean;
    minDate?: Date;
    maxDate?: Date;
    restrictedDates?: Date[];
    showSixWeeksByDefault?: boolean;
    workWeekDays?: DayOfWeek[];
    firstDayOfWeek?: DayOfWeek;
    goToDate: Date;
    onSelectedDateChanged: (date: Date) => void;
    theme?: string;
}

const dayPickerStrings = {
    months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    goToToday: 'Go to today',
    weekNumberFormatString: 'Week number {0}',
    prevMonthAriaLabel: 'Previous month',
    nextMonthAriaLabel: 'Next month',
    prevYearAriaLabel: 'Previous year',
    nextYearAriaLabel: 'Next year',
    prevYearRangeAriaLabel: 'Previous year range',
    nextYearRangeAriaLabel: 'Next year range',
    closeButtonAriaLabel: 'Close',
    monthPickerHeaderAriaLabel: '{0}, select to change the year',
    yearPickerHeaderAriaLabel: '{0}, select to change the month',
};
const divStyle: React.CSSProperties = {
    height: 'auto',
};
export const CalendarInline: React.FunctionComponent<ICalendarProps> = (
    props: ICalendarProps,
) => {
    const [selectedDate, setSelectedDate] = React.useState<Date>();

    const onSelectDate = (date: Date): void => {
        setSelectedDate(date);
        props.onSelectedDateChanged(date);
    };

    const onDismiss = () => {
        return selectedDate;
    };

    const navIcons = {
        leftNavigation: 'ChevronLeft',
        rightNavigation: 'ChevronRight'
    };

    return (
        <div style={divStyle}>
            <Calendar
                // eslint-disable-next-line react/jsx-no-bind
                onSelectDate={onSelectDate}
                // eslint-disable-next-line react/jsx-no-bind
                onDismiss={onDismiss}
                isMonthPickerVisible={props.isMonthPickerVisible}
                dateRangeType={props.dateRangeType}
                autoNavigateOnSelection={props.autoNavigateOnSelection}
                showGoToToday={props.showGoToToday}
                value={props.goToDate || selectedDate!}
                firstDayOfWeek={props.firstDayOfWeek ? props.firstDayOfWeek : DayOfWeek.Monday}
                strings={dayPickerStrings}
                highlightCurrentMonth={props.highlightCurrentMonth}
                highlightSelectedMonth={props.highlightSelectedMonth}
                isDayPickerVisible={props.isDayPickerVisible}
                showMonthPickerAsOverlay={props.showMonthPickerAsOverlay}
                showWeekNumbers={props.showWeekNumbers}
                minDate={props.minDate}
                maxDate={props.maxDate}
                restrictedDates={props.restrictedDates}
                showSixWeeksByDefault={props.showSixWeeksByDefault}
                workWeekDays={props.workWeekDays}
                navigationIcons={navIcons}
                className={styles["calendarDayProps-"+props.theme]}
            />
        </div>
    );
};